import { render, staticRenderFns } from "./ServiceDataList.vue?vue&type=template&id=88ba8744"
import script from "./ServiceDataList.vue?vue&type=script&lang=js"
export * from "./ServiceDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports